var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectedImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_24031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9227 2.53833H3.61561C3.02195 2.53833 2.53833 3.02195 2.53833 3.61561V12.9227C2.53833 13.5164 3.02195 14 3.61561 14H12.9227C13.5164 14 14 13.5164 14 12.9227V3.61561C14 3.02195 13.5164 2.53833 12.9227 2.53833ZM12.6916 3.84678V12.6916H3.84678V3.84678H12.6916Z",
    fill: "#283856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30845 1.30845H10.1532V2.15456H11.4617V1.07728C11.4617 0.48362 10.9781 0 10.3844 0H1.07728C0.48362 0 0 0.48362 0 1.07728V10.3844C0 10.9781 0.48362 11.4617 1.07728 11.4617H2.15456V10.1532H1.30845V1.30845Z",
    fill: "#283856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_24031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedImages);
export default __webpack_public_path__ + "static/media/ConnectedImages.c070907bbdb424480589c8588fdcb8d4.svg";
export { ForwardRef as ReactComponent };